import { render, staticRenderFns } from "./AllReviewContent.vue?vue&type=template&id=35798bf6"
import script from "./AllReviewContent.vue?vue&type=script&lang=js"
export * from "./AllReviewContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports